import type { RentChange } from "../lib/realestate";

export interface DraftRentChangeRow {
  id: string;
  effectiveFrom: string;
  coldRentCents: number;
  sideCostsAdvanceCents: number;
  notes: string | null;
}

export type ValidationResult = "OK" | "BEFORE_MOVE_IN" | "AFTER_MOVE_OUT" | "INVALID_AMOUNT";

export function initDraftRowsMap(rentChanges: RentChange[]): Map<string, DraftRentChangeRow> {
  const map = new Map<string, DraftRentChangeRow>();
  for (const rc of rentChanges) {
    map.set(rc.id, {
      id: rc.id,
      effectiveFrom: rc.effectiveFrom,
      coldRentCents: rc.coldRentCents,
      sideCostsAdvanceCents: rc.sideCostsAdvanceCents,
      notes: rc.notes,
    });
  }
  return map;
}

export function isRowChanged(draft: DraftRentChangeRow, original: RentChange): boolean {
  return (
    draft.effectiveFrom !== original.effectiveFrom ||
    draft.coldRentCents !== original.coldRentCents ||
    draft.sideCostsAdvanceCents !== original.sideCostsAdvanceCents ||
    (draft.notes ?? null) !== (original.notes ?? null)
  );
}

export function validateDraftRow(
  draft: DraftRentChangeRow,
  moveInDate: string,
  moveOutDate: string | null,
): ValidationResult {
  if (draft.coldRentCents <= 0 || draft.sideCostsAdvanceCents < 0) return "INVALID_AMOUNT";
  if (draft.effectiveFrom < moveInDate) return "BEFORE_MOVE_IN";
  if (moveOutDate !== null && draft.effectiveFrom > moveOutDate) return "AFTER_MOVE_OUT";
  return "OK";
}
